// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xe-W","selected":"styles_selected__6OqFQ"};